export default __webpack_public_path__ + "static/media/timer.1f7202f2.svg";